module.exports = __webpack_public_path__ + "static/media/clipboard.a2031fa9.svg";